import settings from "../../config/settings"
const axios = require("axios");

export default class SideNavService {
  deleteProject = async (projectId: any) => {
    let token = localStorage.getItem("keycloak-token");
    const params = new URLSearchParams({
      projectId: projectId,
    });
    return await axios
      .delete(settings.apiUrl + "project?" + params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((resp: any) => resp);
  };
}
